import { render } from "./visitor-setting.vue?vue&type=template&id=5c3874c7&scoped=true&ts=true"
import script from "./visitor-setting.vue?vue&type=script&lang=ts"
export * from "./visitor-setting.vue?vue&type=script&lang=ts"

import "./visitor-setting.vue?vue&type=style&index=0&id=5c3874c7&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3874c7"]])

export default __exports__